export default __webpack_public_path__ + "static/media/icon-lock.ebca1d4d.svg";